import jsPDF from 'jspdf';

class DocumentHelper {
  constructor(documentOrPages, nameForPages) {
    this.document =
      documentOrPages instanceof Array
        ? { pages: documentOrPages, name: nameForPages }
        : documentOrPages;
  }

  download(cbkProgressStep) {
    this.toPdf(doc => {
      doc.save(this.document.name + '.pdf');
    }, cbkProgressStep);
  }

  getFile(cbkProgressStep, cbkResult) {
    this.toPdf(doc => {
      cbkResult(doc.output('blob'));
    }, cbkProgressStep);
  }

  print(cbkProgressStep) {
    this.toPdf(doc => {
      doc.autoPrint(); // in Chrome muss PopUp erlaubt sein
      window.open(doc.output('bloburl'), '_blank');
    }, cbkProgressStep);
  }

  toPdf(pdfReady, cbkProgressStep) {
    let pages = this.document.pages.length;
    let step = 1 / ((pages * 2) / 100);

    if (pages > 0) {
      let doc = new jsPDF('p', 'mm', 'a4'); // p = portrait mode, measurement = mm, format = a4
      let urlMap = new Map();

      let pageCounter = 0;
      let processPage = () => {
        this.toCanvas(
          pageCounter,
          this.document.pages[pageCounter].url,
          (canvas, dataPageCounter) => {
            urlMap.set(dataPageCounter, canvas);

            if (cbkProgressStep) {
              cbkProgressStep(step);
            }

            if (urlMap.size === pages) {
              for (let i = 0; i < pages; i++) {
                doc.addImage(urlMap.get(i), 'JPEG', 0, 0, 210, 297); // addImage(imageData, format, x, y, width (Ziel in mm), height (Ziel in mm), alias, compression, rotation)
                if (i + 1 !== pages) {
                  //am Ende des PDF keine leere Seite mehr hinzufügen
                  doc.addPage();
                }
                if (cbkProgressStep) {
                  cbkProgressStep(step);
                }
              }

              if (cbkProgressStep) {
                cbkProgressStep(100);
              }

              pdfReady(doc);
            } else {
              pageCounter++;
              processPage();
            }
          }
        );
      };
      processPage();
    }
  }

  toCanvas(dataPageCounter, url, callback) {
    const image = new Image();

    image.setAttribute('crossorigin', 'anonymous');
    image.onload = () => {
      var canvas = document.createElement('canvas');
      // A4 -  96 dpi  794 x 1123
      // A4 - 150 dpi 1240 x 1754
      // A4 - 300 dpi 2480 x 3508
      canvas.width = 1240;
      canvas.height = 1754;
      var context = canvas.getContext('2d');
      context.fillStyle = 'white';
      context.fillRect(0, 0, canvas.width, canvas.height);

      var imageAspectRatio = image.width / image.height;
      var canvasAspectRatio = canvas.width / canvas.height;
      var renderableHeight, renderableWidth, xStart, yStart;

      // If image's aspect ratio is less than canvas's we fit on height
      // and place the image centrally along width
      if (imageAspectRatio < canvasAspectRatio) {
        renderableHeight = canvas.height;
        renderableWidth = image.width * (renderableHeight / image.height);
        xStart = (canvas.width - renderableWidth) / 2;
        yStart = 0;
      }

      // If image's aspect ratio is greater than canvas's we fit on width
      // and place the image centrally along height
      else if (imageAspectRatio > canvasAspectRatio) {
        renderableWidth = canvas.width;
        renderableHeight = image.height * (renderableWidth / image.width);
        xStart = 0;
        yStart = (canvas.height - renderableHeight) / 2;
      }

      // Happy path - keep aspect ratio
      else {
        renderableHeight = canvas.height;
        renderableWidth = canvas.width;
        xStart = 0;
        yStart = 0;
      }

      context.drawImage(
        image,
        xStart,
        yStart,
        renderableWidth,
        renderableHeight
      );

      callback(canvas, dataPageCounter);
    };

    image.src = url; // + '?x-request=html'; this x-request workaround is for S3 only, no need with CloudFront links
  }

  convertPagesToDataUrls(onDone) {
    let done = 0;
    this.document.pages.forEach((page, index) => {
      this.toDataUrl(-1, page.url, url => {
        this.document.pages[index].url = url;
        done++;
        if (done === this.document.pages.length) {
          onDone();
        }
      });
    });
  }

  toDataUrl = (dataPageCounter, url, callback) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => {
      const reader = new FileReader();
      reader.onloadend = () => {
        callback(reader.result, dataPageCounter);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhr.setRequestHeader('Access-Control-Request-Method', 'GET');
    xhr.responseType = 'blob';
    xhr.send();
  };
}

export default DocumentHelper;
